import useSWR from 'swr';
import { NativeMember, NativeMemberCardProduct } from '@repo/types';
import { getNativeMemberCardProducts, nativeMemberMe } from '../fetchers/native-membership';
import { useMembershipMode } from '../../widgetsConfiguration';

// SWR cache key for the authenticated member's profile, shared with callers that
// seed the cache after login (so the key matches exactly).
export const nativeMemberMeKey = (token: string) => ['native-member-me', token];

// Fetches the authenticated native member's profile. Keyed on the token so it
// refetches on login/logout and never fires when logged out (key === null).
export function useNativeMember(token: string | null) {
    const { data, error, isLoading, mutate } = useSWR<NativeMember>(
        token ? nativeMemberMeKey(token) : null,
        async () => nativeMemberMe(token as string),
        {
            revalidateOnFocus: false,
        },
    );

    return { data, error, isLoading, mutate };
}

// Purchasable member-card catalog. Only fetches for native tenants (key null otherwise).
// Locale-independent cache key — the response carries all-locale translation maps.
export function useNativeMemberCardProducts() {
    const isNative = useMembershipMode() === 'native';

    const { data, error, isLoading } = useSWR<NativeMemberCardProduct[]>(
        isNative ? 'native-member-card-products' : null,
        async () => getNativeMemberCardProducts(),
        {
            revalidateOnFocus: false,
        },
    );

    return { products: data ?? [], error, isLoading };
}
